import Vue from 'vue';
import './plugins/bootstrap-vue';
import './plugins/airbnbStyleDatepicker';
import './plugins/axios';
import './plugins/vuelidate-error-extractor';
import './plugins/vue-select';
import './plugins/vue-form-wizard';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './assets/css/themify-icons.css';

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
